// extracted by mini-css-extract-plugin
module.exports = {"mb-20px":"_2D2QRnhasS-ImFdgJhGfzw","feature-row":"_2V5ifJP8dPdSkf4DwsS35r","btn-link-cancel":"_1LoYy2IhoCBE3SzuBxQnum","active-until-text":"DOQEYPsP3Zkq0oefh5k15"};